import { useCallback } from 'react';

import {
  selectAuth,
  useAppDispatch,
  useAppSelector,
} from '@/store/hooks/index';
import {
  AuthStoreState,
  SET_ALLOW_MARKETING_NOTIFICATIONS,
  SET_IS_JWT_LOADING,
} from '@/store/slices/auth.slice';

export const useAuthStore = () => {
  const { isJwtLoading, allow_marketing_notifications } =
    useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  const setIsJwtLoading = useCallback(
    (data: AuthStoreState['isJwtLoading']) =>
      dispatch(SET_IS_JWT_LOADING(data)),
    [dispatch]
  );

  const setAllowMarketingNotification = (value: boolean) =>
    dispatch(SET_ALLOW_MARKETING_NOTIFICATIONS(value));

  return {
    allow_marketing_notifications,
    isJwtLoading,
    setIsJwtLoading,
    setAllowMarketingNotification,
  };
};
